/**
 * Um voucher da tela Vouchers (#5022): o `VoucherView` de sempre mais a viagem que o
 * carrega, quando há uma. A lista é transversal a viagens; o vínculo voucher → viagem
 * mora no trip-api (`order.voucherIds`), que o resolve antes de mandar. `trip: null` =
 * nenhuma order do viajante carrega o voucher (órfão, dispensado ou desvinculado).
 */
import { z } from 'zod';

import { VoucherViewSchema } from './traveler_view';

export const VoucherTripRefSchema = z.object({
  id: z.string().min(1),
  /** `manualName ?? título derivado SEM o período` ("Viagem CNF → JOI"): a linha da
   *  tela Vouchers já mostra a data da solicitação ao lado (#5255). */
  name: z.string(),
});
export type VoucherTripRef = z.infer<typeof VoucherTripRefSchema>;

export const VoucherListItemSchema = VoucherViewSchema.extend({
  trip: VoucherTripRefSchema.nullable(),
});
export type VoucherListItem = z.infer<typeof VoucherListItemSchema>;
